












































































import Vue from "vue";
import TheSignUpForm from "@/components/TheSignUpForm.vue";

export default Vue.extend({
  name: "App",

  components: {
    TheSignUpForm,
  },

  data: () => ({
    //
  }),
});
